import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import LaunchIcon from '@mui/icons-material/Launch'

type Props = {
  title: string
  linkTitle?: string
  link?: string
}

export default function SectionTitle({ title, link, linkTitle }: Props) {
  const navigate = useNavigate()
  return (
    <Box
      display={'flex'}
      flexDirection={'row'}
      justifyContent={'space-between'}
      alignItems={'center'}
      mt={3.2}
      mb={1.6}
    >
      <Typography component="div" variant="h7">
        {title}
      </Typography>
      {link ? (
        <Button
          color="primary"
          variant="text"
          size="small"
          sx={{
            textTransform: 'none',
            fontWeight: 'medium',
          }}
          onClick={() => {
            navigate(link)
          }}
        >
          {linkTitle}
          <LaunchIcon
            sx={{
              ml: 1,
              fontSize: '18px',
            }}
          />
        </Button>
      ) : null}
    </Box>
  )
}
